/* eslint-disable */

import {useEffect, useRef} from "react"

const ScrollEvent = (props) => {

    const mobileStart = useRef({});
    const isScrolling = useRef();
    const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    useEffect(() => {

        if(props.target && !props.disabled){

            // initiate the event handler
            // modern Chrome requires { passive: false } when adding event
            let supportsPassive = false;
            try {
                props.target.addEventListener("test", null, Object.defineProperty({}, 'passive', {
                    get: function () { supportsPassive = true; }
                }));
            } catch(e) {}

            let wheelOpt = supportsPassive ? { passive: false } : false;

            // props.target.addEventListener('DOMMouseScroll', scrollFunction, false); // older FF
            props.target.addEventListener(wheelEvent, scrollFunction, wheelOpt); // modern desktop
            props.target.addEventListener('touchstart', touchScroll,  wheelOpt); // mobile
            window.addEventListener('keydown', keyScroll, false);

            if(props.disabled) removeEvents()
            return ()=> removeEvents();
        }

    }, [props.target, props.scroll, props.disabled])

    function scrollFunction(e){

        window.clearTimeout( isScrolling.current );

        isScrolling.current = setTimeout(() => {
            props.scroll(e)
        }, props.debounce);

    }

    function removeEvents(){
        window.clearTimeout( isScrolling.current );
        // props.target.removeEventListener('DOMMouseScroll', scrollFunction);
        props.target.removeEventListener(wheelEvent, scrollFunction);
        props.target.removeEventListener('touchstart', touchScroll);
        window.removeEventListener('keydown', keyScroll);
        props.target.removeEventListener('touchmove', touchMoveValue);
        if(props.mobileCheck) props.target.removeEventListener('scroll', scrollFunction);
    }

    function keyScroll(e) {
        // left: 37, up: 38, right: 39, down: 40, spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
        let keys = { 38: 50, 40: -50};
        if (keys[e.keyCode]) {
            let delta = { touchDeltaY: keys[e.keyCode] };
            scrollFunction(delta);
            return false;
        }
    }

    function touchScroll(e){
        mobileStart.current = {x: e.touches[0].pageX, y: e.touches[0].pageY};

        /** not sure the touch move ended when your finger lifted, we need to track
         * the scroll further on mobile devices for the "next Check" functions **/
        if(props.mobileCheck){
            props.target.addEventListener('scroll', scrollFunction, { passive: false });
        } else {
            props.target.addEventListener('touchmove', touchMoveValue, { passive: false });
        }

    }

    function touchMoveValue (e){

        let contact = e.touches,
            endX = contact[0].pageX,
            endY = contact[0].pageY,
            distanceX = endX - mobileStart.current.x,
            distanceY = endY - mobileStart.current.y,
            delta = { touchDeltaX: distanceX, touchDeltaY: distanceY };

        scrollFunction(delta)

        props.target.removeEventListener('touchmove', touchMoveValue)
    }

    return <></>;

}

export default ScrollEvent;